/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { QuestionSquareIcon16Light } from './QuestionSquareIcon16Light';
import { QuestionSquareIcon16Regular } from './QuestionSquareIcon16Regular';
import { QuestionSquareIcon16Solid } from './QuestionSquareIcon16Solid';
import { QuestionSquareIcon20Light } from './QuestionSquareIcon20Light';
import { QuestionSquareIcon20Regular } from './QuestionSquareIcon20Regular';
import { QuestionSquareIcon20Solid } from './QuestionSquareIcon20Solid';
import { QuestionSquareIcon24Regular } from './QuestionSquareIcon24Regular';
import { QuestionSquareIcon24Solid } from './QuestionSquareIcon24Solid';
import { QuestionSquareIcon32Regular } from './QuestionSquareIcon32Regular';
import { QuestionSquareIcon64Regular } from './QuestionSquareIcon64Regular';
var sizes = {
    16: {
        light: QuestionSquareIcon16Light,
        regular: QuestionSquareIcon16Regular,
        solid: QuestionSquareIcon16Solid,
    },
    20: {
        light: QuestionSquareIcon20Light,
        regular: QuestionSquareIcon20Regular,
        solid: QuestionSquareIcon20Solid,
    },
    24: {
        regular: QuestionSquareIcon24Regular,
        solid: QuestionSquareIcon24Solid,
    },
    32: {
        regular: QuestionSquareIcon32Regular,
    },
    64: {
        regular: QuestionSquareIcon64Regular,
    },
};
export var QuestionSquareIcon = forwardRef('QuestionSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
